import {Directive, Output, EventEmitter} from '@angular/core'

@Directive({selector: '[on-tab-active]'})
export class WizardOnTabActive {

    @Output('on-tab-active') listener: EventEmitter<string> = new EventEmitter<string>();

    activate(tabId: string) {
        this.listener.emit(tabId);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/wizard/wizard.tab.lifecycle.ts